import React from 'react';
import styled from 'styled-components';
import theme from '../../theme';
import { Link } from 'react-router-dom';

import Paragraph from "../shared/Paragraph";

import { TimelineMax, Power1 } from "gsap";

class NewsItem extends React.Component {
  constructor(props) {
    super(props);

    this.timeline = new TimelineMax({ paused: true });
  }

  componentDidMount() {
    const { delay, itemId } = this.props;

    this.timeline
      .from(this.article, 1.2, {
        autoAlpha: 0,
        y: 20,
        ease: Power1.ease,
        delay: delay * itemId + .5
      })

    this.timeline.play();
  }

  render() {
    const { name, link, description, main_image } = this.props.article;

    return (
      <LinkWrapper>
        <Link to={`/${window.language}/${window.newsLink}/${link}`}>
          <NewsItemStyled ref={article => (this.article = article)}>
            <img src={main_image} alt={name} />
            <InnerContent>
              <Title>{name}</Title>
              <Paragraph>
                {description}
              </Paragraph>
            </InnerContent>
          </NewsItemStyled>
        </Link>
      </LinkWrapper>
    )
  }
}

const LinkWrapper = styled.div`
  a:hover {
    text-decoration: none;
  }
`

const InnerContent = styled.div`
  margin-left: 55px;
`

const Title = styled.h2`
  font-size: 27px;
  color: ${theme.colors.primary};
  margin: 0;
`

const NewsItemStyled = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 55px;
  padding-bottom: 55px;
  border-bottom: 1px solid #ebeff1;
`;

export default NewsItem;